export default __webpack_public_path__ + "static/media/user-avatar_light.1f261431.svg";